import { getData, postData, putData, deleteData } from "../apiClient";

// get users with pagination
export const getRoomFacilitiesWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/room-facility/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get Room Facilities with pagination API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};

// get user data with id
export const getRoomFacilitieDataWithId = async (id) => {
  try {
    const result = await getData(`/room-facility/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get user data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create user ** // Updated Api Error Handle Method
export const createRoomFacilityType = async ({ data }) => {
  try {
    const result = await postData(`/room-facility/`, data);
    
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("user add API error:", error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete user
export const deleteRoomFacilitie = async ({ id }) => {
  try {
    const result = await deleteData(`/room-facility/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Delete user API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// update user data
export const updateRoomFacilitie = async ({id, data }) => {
  try {
    const result = await putData(`/room-facility/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update user API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};
